import React from 'react';

var getRoundingFunction = function getRoundingFunction(quantityStepRounding) {
  if (quantityStepRounding === 'down') {
    return Math.floor;
  } // quantityStepRounding === 'up'


  return Math.ceil;
};

var justifyQuantity = function justifyQuantity(_ref, quantity) {
  var quantityMax = _ref.quantityMax,
      quantityMin = _ref.quantityMin,
      quantityStep = _ref.quantityStep,
      quantityStepRounding = _ref.quantityStepRounding;
  if (quantity <= 0) return 0;

  if (quantityStep > 1) {
    var fraction = quantity / quantityStep;
    var fold = getRoundingFunction(quantityStepRounding)(fraction);
    return Math.min(Math.max(fold * quantityStep, quantityMin), quantityMax);
  }

  return Math.min(Math.max(quantity, quantityMin), quantityMax);
};

export default function useJustifyQuantity(_ref2) {
  var quantityMax = _ref2.quantityMax,
      quantityMin = _ref2.quantityMin,
      quantityStep = _ref2.quantityStep,
      quantityStepRounding = _ref2.quantityStepRounding;
  return React.useCallback(function (quantity) {
    return justifyQuantity({
      quantityMax: quantityMax,
      quantityMin: quantityMin,
      quantityStep: quantityStep,
      quantityStepRounding: quantityStepRounding
    }, quantity);
  }, [quantityMax, quantityMin, quantityStep, quantityStepRounding]);
}